angular.module('aprima-core', [
    'lodash', 
    'angular-cache',
    'ngNumeraljs',
]);
